import { Component, ElementRef, signal, viewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { MobileDrawerComponent } from './mobile-drawer/mobile-drawer.component';
import { VerificationBannerComponent } from '../../components/verification-banner/verification-banner.component';

@Component({
  selector: 'app-authenticated-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, MobileDrawerComponent, VerificationBannerComponent],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
})
export class AuthenticatedLayoutComponent {
  readonly drawerOpen = signal(false);
  private readonly hamburgerBtn = viewChild<ElementRef<HTMLButtonElement>>('hamburgerBtn');

  openDrawer(): void {
    this.drawerOpen.set(true);
  }

  closeDrawer(): void {
    this.drawerOpen.set(false);
    queueMicrotask(() => this.hamburgerBtn()?.nativeElement.focus());
  }
}
